import PropTypes from 'prop-types';
import React from 'react';

import Table from '../../../../ComponentLibrary/oc-table';
import { connectLocation } from '../../../../location/LocationConnectors';
import { ResultsCard } from '../../styles';

const pct = v => (typeof v === 'number' && Number.isFinite(v) ? `${v.toFixed(2)}%` : '—');

const WallAreaFactorsCard = ({ structurePercent, cavityPercent, t }) => (
  <div style={{ marginTop: 16 }}>
    {/* grey section header bar */}
    <div
      style={{
        background: '#E6E6E6',
        color: '#1E1E1E',
        fontWeight: 700,
        padding: '10px 12px',
        borderTopLeftRadius: 6,
        borderTopRightRadius: 6,
      }}
    >
      Wall Area Factors
    </div>

    <ResultsCard style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
      <Table striped bordered fixedTableLayout firstLeft margin="0">
        <tbody>
          <tr>
            <td className="row-heading">{t('thermal_calculator.walls_above_grade.structure')}</td>
            <td style={{ textAlign: 'center' }}>{pct(structurePercent)}</td>
          </tr>
          <tr>
            <td className="row-heading">{t('thermal_calculator.walls_above_grade.cavity')}</td>
            <td style={{ textAlign: 'center' }}>{pct(cavityPercent)}</td>
          </tr>
        </tbody>
      </Table>
    </ResultsCard>
  </div>
);

WallAreaFactorsCard.propTypes = {
  structurePercent: PropTypes.number, // e.g., 0.77
  cavityPercent: PropTypes.number, // e.g., 99.23
  t: PropTypes.func.isRequired,
};

WallAreaFactorsCard.defaultProps = {
  structurePercent: null,
  cavityPercent: null,
};

export default connectLocation(WallAreaFactorsCard);
